import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Icon from '../../../components/AppIcon';

const RevenueAnalyticsChart = ({ timePeriod = 'month' }) => {
  const revenueData = [
    { month: 'Jan', revenue: 1240000, subscriptions: 782, churn: 3.2 },
    { month: 'Feb', revenue: 1380000, subscriptions: 821, churn: 2.8 },
    { month: 'Mar', revenue: 1520000, subscriptions: 856, churn: 2.5 },
    { month: 'Apr', revenue: 1680000, subscriptions: 892, churn: 2.1 },
    { month: 'May', revenue: 1750000, subscriptions: 924, churn: 1.9 },
    { month: 'Jun', revenue: 1840000, subscriptions: 958, churn: 1.7 }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-white border border-slate-200 rounded-lg p-4 elevation-lg">
          <p className="text-sm font-semibold text-slate-900 mb-2">
            {payload?.[0]?.payload?.month}
          </p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-6 text-sm">
              <span className="text-slate-600">{entry?.name}:</span>
              <span className="font-semibold text-slate-900">
                {entry?.name === 'Revenue' ? `₹${(entry?.value / 100000)?.toFixed(1)}L` : entry?.value}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-6 elevation-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-bold text-slate-900 font-heading">
            Revenue & Subscription Analytics
          </h3>
          <p className="text-sm text-slate-600 font-body mt-1">
            Track revenue trends and subscription growth
          </p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-50 rounded-lg">
            <Icon name="TrendingUp" size={16} color="#10B981" />
            <span className="text-sm font-semibold text-emerald-600">+15.7%</span>
          </div>
        </div>
      </div>
      <div className="w-full h-80">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={revenueData}>
            <defs>
              <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#8B5CF6" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#8B5CF6" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis 
              dataKey="month" 
              stroke="#64748B"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="#64748B"
              style={{ fontSize: '12px' }}
              tickFormatter={(value) => `₹${(value / 100000)?.toFixed(0)}L`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Area
              type="monotone"
              dataKey="revenue"
              name="Revenue"
              stroke="#8B5CF6"
              strokeWidth={2}
              fill="url(#revenueGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-slate-200">
        <div>
          <p className="text-xs text-slate-600 mb-1">Total Revenue</p>
          <p className="text-xl font-bold text-slate-900">₹18.4L</p>
        </div>
        <div>
          <p className="text-xs text-slate-600 mb-1">Avg. Churn Rate</p>
          <p className="text-xl font-bold text-slate-900">2.4%</p>
        </div>
        <div>
          <p className="text-xs text-slate-600 mb-1">Growth Rate</p>
          <p className="text-xl font-bold text-emerald-600">+15.7%</p>
        </div>
      </div>
    </div>
  );
};

export default RevenueAnalyticsChart;